import Home from "pages/Home";
import React, { useEffect, useState } from "react";
import { fetchRestricatCategoryDataCount, getRestrictedCategories, getRestrictedDesign } from "./api/restrictedPageApis";
import { colors, Grid, Typography } from "@mui/material";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { Card } from "components/ui";
import { useLocation, useNavigate } from "react-router-dom";
import { encodeStr } from "utils/encodeDecodeStr";
import { useSettingContext } from "context/SettingContext";
import { useGlobalContext } from "context/GlobalContext";
import { transformData } from "utils/transformdata";
import Product from "features/Category/categoryProd/components/Product";
import SingleProduct from "./RestrictProductPage/SingleProduct";
import { useFilter } from "context/FilterContext";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

function RestrictedDesignCategoryPage() {
  const { setRestricateCatagoryCount, search, setSearch, setSearchBar, restricateCatagoryCount } = useSettingContext();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchPlaceHolder, setSearchResultCount, filterChangeCount } = useGlobalContext();
  const { setFilterCount } = useFilter();

  const [data, setData] = useState([]);
  const [design, setDesign] = useState([]);
  const [restricateCatagoryDynamicCount, setRestricateCatagoryDynamicCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();

  const handleClick = (data) => {
    let newState = {
      ...location.state,
      name: [`${location?.state?.name[0]?.split(" - ")[0]}`, `${data?.category}`],
      restrictedCategorySearch: search !== "" ? search : "",
      restrictedSubCatgeorySearch: "",
    };
    navigate(`/Setting/restricted-designs/${encodeStr(data?.category)}`, { state: newState });
  };

  useEffect(() => {
    setSearchBar(true);
    setSearchPlaceHolder("Search By Category or Design Number");
    setFilterCount(0);
    return () => {
      setSearchBar(false);
      setSearch("");
      setSearchPlaceHolder("");
      setFilterChangeDesignCount(0);
      setFilterCount(0);
      setSearchResultCount(0);
      setFilterChangeCount(0);
    };
  }, []);

  useEffect(() => {
    if (!isReady) return;
    const fetchRestrictedCategories = async () => {
      let response = await getRestrictedCategories({ searchTerm: search });

      if (response.status === 200) {
        setData(response?.categories || []);
        setDesign(response?.cardData || []);
        setFilterChangeDesignCount(response.totalDesigns);
        if (search !== "") {
          setSearchResultCount(response.totalCategory);
        }
        setLoading(false);
      } else {
        alert("something went wrong");
      }
    };

    const fetchRestricatCategoryCount = async () => {
      try {
        const response = await fetchRestricatCategoryDataCount();

        if (response) {
          setRestricateCatagoryCount(response);
          setRestricateCatagoryDynamicCount(response.totalCategoryCount);
          // setFilterChangeDesignCount(response.totalDesginCount);
          setFilterChangeCount(response.totalCategoryCount);
        } else {
          alert("Something went wrong while fetching category data count");
        }
      } catch (error) {
        alert("Error fetching category data count");
      }
    };

    fetchRestricatCategoryCount();
    fetchRestrictedCategories();
  }, [search, isReady]);

  useEffect(() => {
    setDisplayCount(true);
    return () => {
      setDisplayCount(false);
    };
  }, [data]);

  useEffect(() => {
    setSearch(location?.state?.restrictedCategorySearch || "");
    setIsReady(true);
  }, [location]);

  if (loading) return <LoadingSmallCard count={24} />;

  const hasNoResults =
    search &&
    !data?.length &&
    !design?.length

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;
  return (
    <>
      {(data && data.length > 0) || (design && design.length > 0) ? (
        <Grid
          container
          className="Grid-padding"
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            rowGap: "32px",
          }}
        >
          {data && data.length > 0
            ? data.map((ele, i) => (
                <Grid item key={i} onClick={() => handleClick(ele)}>
                  <Card style={{ minWidth: 275, maxWidth: "317px", height: 62, borderRadius: "5px" }}>
                    <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                      {ele.category}
                    </Typography>
                    <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                      {ele.count}
                    </Typography>
                  </Card>
                </Grid>
              ))
            : design.map((design) => {
                const transformedProduct = transformData(design);
                return <SingleProduct product={transformedProduct} key={design._id} />;
              })}
        </Grid>
      ) : (
        <Home />
      )}
    </>
  );
}

export default RestrictedDesignCategoryPage;
